import React, { useState, useEffect } from "react";
import MobilePasswordForm from "./MobilePasswordForm";
import MobilePhoneForm from "./MobilePhoneForm";
import MobileRegistrationForm from "./MobileRegistrationForm";
import { useRouter } from "next/router";
export default function MobileDesktop({
  formFields,
  countryCode,
  responseSocial,
  dispatcher,
  validators,
  passValidators,
  phoneValidators,
  veriCallback,
  moveToVerification,
  moveToCompanyInfo,
  options,
  onChangeDropdown,
  moveToDot,
  onChange,
  buttonClicked,
  toSecond,
}) {
  const router = useRouter();

  const [screen2, setScreen2] = useState(false);
  const [screen3, setScreen3] = useState(false);
  const [screen4, setScreen4] = useState(false);
  const [screen5, setScreen5] = useState(false);
  const [screen6, setScreen6] = useState(false);

  const callback = (openSecond) => {
    setScreen2(openSecond);
  };
  useEffect(() => {
    if (moveToVerification) {
      setScreen2(false);
      setScreen3(false);
      setScreen5(false);
      setScreen4(true);
    }
  }, [moveToVerification]);
  useEffect(() => {
    if (moveToDot) {
      setScreen2(false);
      setScreen3(false);
      setScreen5(true);
      setScreen4(false);
    }
  }, [moveToDot]);
  useEffect(() => {
    if (moveToCompanyInfo) {
      setScreen2(false);
      setScreen3(false);
      setScreen5(false);
      setScreen4(false);
      setScreen5(false);
      setScreen6(true);
    }
  }, [moveToCompanyInfo]);
  const callback1 = (openThird) => {
    setScreen3(openThird);
    setScreen2(false);
    setScreen5(false);
  };
  const callback2 = (openForth) => {
    setScreen2(false);
    setScreen3(false);
    setScreen5(false);
    setScreen4(openForth);
  };

  const onBackPasswordClick = () => {
    setScreen2(false);
    setScreen3(false);
    setScreen5(false);
    setScreen6(false);
    setScreen4(false);
  };

  const onBackPhoneClick = () => {
    setScreen2(true);
    setScreen3(false);
    setScreen5(false);
    setScreen6(false);
    setScreen4(false);
  };
  return (
    <div className="bg-Body flex flex-row  custom2:hidden ">
      <div className={`w-full min-h-screen `}>
        <div
          className=" flex flex-row justify-center pt-4 cursor-pointer   items-center"
          onClick={() => router.push("/")}
        >
          {process.env.NEXT_PUBLIC_THEME === "LT" ? (
            <>
              <img
                src="/Images/logo-circle.webp"
                width={"36px"}
                height={"36px"}
                className="  rounded-full"
              />
              <img
                src="/Images/wordmark-luckytruck.webp"
                width={"131px"}
                height={"32px"}
              />
            </>
          ) : (
            <img src="/Images/flexport/Logo-flexport.webp" width={"150px"} />
          )}
        </div>
        {!screen2 && !screen3 && !screen4 && !screen5 && !screen6 ? (
          <MobileRegistrationForm
            dispatcher={dispatcher}
            responseSocial={responseSocial}
            formFields={formFields}
            validators={validators}
            callback={callback}
            onChange={onChange}
          />
        ) : screen2 && !screen3 && !screen4 && !screen5 ? (
          <MobilePasswordForm
            callback={callback1}
            passValidators={passValidators}
            onBackPasswordClick={onBackPasswordClick}
            onChange={onChange}
            formField={formFields.password}
          />
        ) : !screen2 && !screen5 && screen3 ? (
          <MobilePhoneForm
            callback={callback2}
            onBackPhoneClick={onBackPhoneClick}
            countryCode={countryCode}
            phoneValidators={phoneValidators}
            options={options}
            onChangeDropdown={onChangeDropdown}
            formField={formFields.phone}
            onChange={onChange}
            buttonClicked={buttonClicked}
            toSecond={toSecond}
            veriCallback={veriCallback}
          />
        ) : null}

        {/* <MobileDotForm /> */}
        {/* <MobileCompanyInfo /> */}
      </div>

      {/*TODO: For Testing Purpose - remove later */}
    </div>
  );
}
